export const expression = /[^\d]/g;

export default (input: string): string => input.replace(expression, '');
